import React from "react";

// Catches render/chunk errors so a failed lazy route never leaves a blank page.
// On a chunk-load error (stale bundle after a deploy) it reloads once automatically.
export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    const msg = String(error?.message || error || "");
    const isChunk = /ChunkLoadError|Loading chunk|dynamically imported module|Failed to fetch/i.test(msg);
    const KEY = "route_err_reload_ts";
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (isChunk && Date.now() - last > 10000) {
      sessionStorage.setItem(KEY, String(Date.now()));
      window.location.reload();
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="grid min-h-[60vh] place-items-center px-6 text-center" data-testid="route-error">
          <div>
            <div className="font-display text-xl font-semibold text-[#0A0A0F]">Un instant…</div>
            <p className="mt-2 text-sm text-[#6B6B70]">La page se met à jour. Si rien ne se passe, actualisez la page.</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-5 inline-flex rounded-full bg-[#0A0A0F] px-6 py-3 text-sm font-medium text-white"
              data-testid="route-error-reload"
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
